"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isEmptyString = function (string) { return !string || /^\s*$/.test(string); };
exports.default = isEmptyString;
